__turbopack_context__.v({
  "list": "_5PZn_a_list",
  "panel": "_5PZn_a_panel",
  "root": "_5PZn_a_root",
  "tab": "_5PZn_a_tab",
  "tabLabel": "_5PZn_a_tabLabel",
  "tabSection": "_5PZn_a_tabSection",
});
